import React from "react";
import Grid from "@material-ui/core/Grid";
import { RatingStats } from "@comparaonline/ui-reviews-rating-stats";
import { RatingSummary } from "@comparaonline/ui-reviews-rating-summary";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";

import { withStyles, Styles } from "./styles";

interface ReviewSummaryProps extends Styles {
  total: number;
  averageValue: number;
  totalByValue: Array<{ total: number; value: number }>;
}

const BaseReviewSummary: React.FC<ReviewSummaryProps> = ({
  averageValue,
  total,
  totalByValue,
  classes
}) => {
  const formatMessage = useFormatMessage();
  return (
    <Grid
      container={true}
      spacing={16}
      direction="column"
      classes={{ container: classes.container }}
    >
      <Grid item={true} xs={12} sm="auto" classes={{ item: classes.summary }}>
        <RatingSummary
          averageValue={averageValue}
          totalRatings={total}
          label={formatMessage("reviews.ratings")}
        />
      </Grid>
      <Grid item={true} xs={12} sm="auto">
        <RatingStats total={total} totalByValue={totalByValue} />
      </Grid>
    </Grid>
  );
};

export const ReviewSummary = withStyles(BaseReviewSummary);
